export default __webpack_public_path__ + "static/Ajib-38ca660f86a462f7c2cce3af114c25fa.jpg";